import { Canvas } from '@react-three/fiber';
import React, { useState } from 'react';
import { ArrowDownShort, ArrowRepeat } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import ProductList from '../test/product-list';
import HumanModel from './human_model';

export default function HumanModelProductViewer() {
	const { t } = useTranslation('component_human_model_product_viewer');
	const [isFrontView, setIsFrontView] = useState(true);
	const [selectedMarker, setSelectedMarker] = useState(null);
	const [showMarkers, setShowMarkers] = useState(true);

	const bodySettings = {
		back: [
			{ id: 'head', label: 't5', position: [[0, 1.4, 0]] },
			{ id: 'back', label: 't6', position: [[0, 1.02, 0]] },
			{
				id: 'leg',
				label: 't7',
				position: [
					[0.1, 0.45, 0],
					[-0.1, 0.45, 0],
				],
			},
			{
				id: 'fot',
				label: 't11',
				position: [
					[0.1, 0.05, 0],
					[-0.1, 0.05, 0],
				],
			},
			{
				id: 'arm',
				label: 't12',
				position: [
					[0.21, 1, 0],
					[-0.21, 1, 0],
				],
			},
			{
				id: 'hand',
				label: 't13',
				position: [
					[0.23, 0.7, 0],
					[-0.23, 0.7, 0],
				],
			},
		],
		front: [
			{ id: 'head', label: 't8', position: [[0, 1.4, 0]] },
			{
				id: 'leg',
				label: 't7',
				position: [
					[0.09, 0.45, 0],
					[-0.09, 0.45, 0],
				],
			},
			{
				id: 'fot',
				label: 't11',
				position: [
					[0.1, 0.05, 0],
					[-0.1, 0.05, 0],
				],
			},
			{
				id: 'arm',
				label: 't12',
				position: [
					[0.21, 1, 0],
					[-0.21, 1, 0],
				],
			},
			{
				id: 'hand',
				label: 't13',
				position: [
					[0.23, 0.7, 0],
					[-0.23, 0.7, 0],
				],
			},
			{ id: 'torso', label: 't10', position: [[0, 1.02, 0]] },
		],
	};

	const handleMarkerClick = (setting) => {
		setSelectedMarker(setting);
		setShowMarkers(false);
	};

	return (
		<div className="position-relative bg-gray-200 rounded-4 human-body-product-viewer-wrapper o-hidden">
			<Canvas
				camera={{
					fov: 50,
					position: [0, 1, 1.8],
				}}
				onCreated={({ camera }) => {
					camera.lookAt(0, 1, 0);
				}}
			>
				{/* Lights */}
				<ambientLight intensity={3} />
				<spotLight angle={0.2} penumbra={1} position={[5, 10, 5]} />

				{/* Human Model */}
				<HumanModel
					bodySettings={bodySettings}
					isFrontView={isFrontView}
					onMarkerClick={handleMarkerClick}
					showMarkers={showMarkers}
				/>

				{/* Orbit Controls
				<OrbitControls
					enableRotate={true} // Allow rotation, but restricted
					enableZoom={false} // Disable zoom
					maxAzimuthAngle={Math.PI} // Allow up to 180 degrees (back)
					maxPolarAngle={Math.PI / 2} // Lock vertical rotation to front view
					minAzimuthAngle={0} // Allow rotation from 0 (front)
					minPolarAngle={Math.PI / 2} // Lock vertical rotation to front view
				/>
				*/}
			</Canvas>

			<div className="d-flex align-items-center gap-2 position-absolute top-0 start-0 p-lg-5 p-3">
				<h3 className="title-small"> {t('t1')}</h3>
			</div>
			<div className="d-flex align-items-center gap-2 position-absolute bottom-0 start-0 p-lg-5 p-3 sm d-lg-none">
				<ArrowDownShort className="lead" />
				{t('t2')}
			</div>
			<div className="position-absolute top-0 end-0  p-lg-5 p-3">
				<button
					className="btn btn-dark d-flex align-items-center rounded-pill gap-2   "
					onClick={() => setIsFrontView(!isFrontView)}
				>
					<ArrowRepeat /> {t('t3')} {isFrontView ? t('t4') : t('t5')}
				</button>
			</div>

			{selectedMarker && (
				<div
					className={` human-body-product-viewer-overlay d-flex flex-column gap-2 justify-content-start`}
				>
					<div className="d-flex justify-content-between align-items-center w-100 p-lg-5 p-3">
						<h2 className="section-title fade-in">{t(selectedMarker.label)}</h2>

						<div
							className="bg-dark rounded-circle d-flex align-items-center justify-content-center p-2"
							data-bs-theme="dark"
						>
							<button
								aria-label="Close"
								className="btn-close "
								onClick={() => {
									setSelectedMarker(null);
									setShowMarkers(true);
								}}
								type="button"
							></button>
						</div>
					</div>

					<div className="fade-in overflow-y-auto px-lg-5">
						<ProductList
							grouping={false}
							include_diagnostic_types={['mri']}
							include_tag_content={[selectedMarker.id]}
							include_tag_types={['placement']}
							tracking={{
								item_list_name: 'MR products in human body on MR rontgen page',
								source: 'related',
							}}
							variant="slim"
						/>
					</div>
				</div>
			)}
		</div>
	);
}
